export type SortType = 'asc' | 'desc';

export function sort2RequestParams(sort: string): { sortField: string; sortType: SortType } {
  const [c] = sort;
  if (c === '-') {
    return { sortField: sort.substring(1), sortType: 'desc' };
  }
  return { sortField: sort, sortType: 'asc' };
}
